// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filtru-acasa {
  max-width: 860px;
  margin: 0 auto;
  padding: 20px;
}

.fa-imagine-butoane {
  display: flex;
  justify-content: center;
  gap: 9px;
  margin-bottom: 32px;
  flex-wrap: wrap;
}

.fa-imagine-card {
  background: #fff;
  border: 3px solid #1a1a1a;
  border-radius: 20px;
  padding: 32px;
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 5px 5px 0px #1a1a1a;
  gap: 10px;
  text-align: center;
}
.fa-imagine-card:hover {
  transform: translate(-3px, -3px);
  box-shadow: 9px 9px 0px #000000;
  border-color: #f2c94c;
}
.fa-imagine-icon {
  font-size: 2.5rem;
  color: #1a1a1a;
}
.fa-imagine-card:hover .fa-imagine-icon { color: #f2c94c; }
.fa-imagine-card span {
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.fa-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  color: #aaa;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
}
.fa-divider::before, .fa-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
}

.fa-avansate {
  background: #f9fafb;
  border-radius: 20px;
  padding: 24px;
  border: 1.5px solid #e5e7eb;
}
.fa-avansate h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  font-size: 16px;
  color: #1a1a1a;
}

.fa-body {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  margin-bottom: 18px;
  flex-wrap: wrap;
}

/* Preview */
.fa-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.fa-preview-wrapper { position: relative; }
.fa-preview-img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 12px;
  border: 3px solid #f2c94c;
}
.fa-btn-remove {
  position: absolute;
  top: -8px; right: -8px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px; height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}
.fa-preview-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #f97316;
  font-weight: 600;
}

/* Grid */
.fa-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 14px;
  flex: 1 1;
}

.fa-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.fa-group label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.fa-group select {
  padding: 10px 12px;
  border: 1.5px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
  background: white;
  outline: none;
  cursor: pointer;
}
.fa-group select:focus { border-color: #f97316; }

/* Tip butoane */
.fa-group-tip { grid-column: 1 / -1; }

.fa-tip-butoane {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.fa-tip-btn {
  padding: 10px 20px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s;
}
.fa-tip-btn:hover { border-color: #f2c94c; }
.fa-tip-btn.activ-gasit {
  background: #dcfce7;
  border-color: #16a34a;
  color: #16a34a;
}
.fa-tip-btn.activ-pierdut {
  background: #fee2e2;
  border-color: #dc2626;
  color: #dc2626;
}

/* Acțiuni */
.fa-actiuni { display: flex; gap: 12px; flex-wrap: wrap; }

.fa-btn-cauta {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: #ffcc00;
  color: white;
  border: 2px solid #1a1a1a;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 3px 3px 0px #1a1a1a;
  transition: all 0.2s;
}
.fa-btn-cauta:hover {
  transform: translate(-2px, -2px);
  box-shadow: 5px 5px 0px #1a1a1a;
}
.fa-btn-cauta:disabled { opacity: 0.6; cursor: not-allowed; }

.fa-btn-reset {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  background: white;
  color: #666;
  border: 1.5px solid #ddd;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
}
.fa-btn-reset:hover { background: #f3f4f6; }

@media (max-width: 600px) {
  .fa-body { flex-direction: column; }
  /* .fa-grid { 
    grid-template-columns: repeat(2, 1fr); 
  } */
}`, "",{"version":3,"sources":["webpack://./src/components/FiltruAcasa.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA,0CAA0C,cAAc,EAAE;AAC1D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA,sBAAsB,kBAAkB,EAAE;AAC1C;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;AACA,yBAAyB,qBAAqB,EAAE;;AAEhD,gBAAgB;AAChB,gBAAgB,mBAAmB,EAAE;;AAErC;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA,oBAAoB,qBAAqB,EAAE;AAC3C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,YAAY;AACZ,cAAc,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA,yBAAyB,YAAY,EAAE,mBAAmB,EAAE;;AAE5D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,WAAW,sBAAsB,EAAE;EACnC;;KAEG;AACL","sourcesContent":[".filtru-acasa {\n  max-width: 860px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.fa-imagine-butoane {\n  display: flex;\n  justify-content: center;\n  gap: 9px;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n}\n\n.fa-imagine-card {\n  background: #fff;\n  border: 3px solid #1a1a1a;\n  border-radius: 20px;\n  padding: 32px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 5px 5px 0px #1a1a1a;\n  gap: 10px;\n  text-align: center;\n}\n.fa-imagine-card:hover {\n  transform: translate(-3px, -3px);\n  box-shadow: 9px 9px 0px #000000;\n  border-color: #f2c94c;\n}\n.fa-imagine-icon {\n  font-size: 2.5rem;\n  color: #1a1a1a;\n}\n.fa-imagine-card:hover .fa-imagine-icon { color: #f2c94c; }\n.fa-imagine-card span {\n  font-weight: 700;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.fa-divider {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 24px;\n  color: #aaa;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n.fa-divider::before, .fa-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e5e7eb;\n}\n\n.fa-avansate {\n  background: #f9fafb;\n  border-radius: 20px;\n  padding: 24px;\n  border: 1.5px solid #e5e7eb;\n}\n.fa-avansate h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 18px;\n  font-size: 16px;\n  color: #1a1a1a;\n}\n\n.fa-body {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n  margin-bottom: 18px;\n  flex-wrap: wrap;\n}\n\n/* Preview */\n.fa-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.fa-preview-wrapper { position: relative; }\n.fa-preview-img {\n  width: 120px;\n  height: 120px;\n  object-fit: cover;\n  border-radius: 12px;\n  border: 3px solid #f2c94c;\n}\n.fa-btn-remove {\n  position: absolute;\n  top: -8px; right: -8px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px; height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n}\n.fa-preview-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: #f97316;\n  font-weight: 600;\n}\n\n/* Grid */\n.fa-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 14px;\n  flex: 1;\n}\n\n.fa-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.fa-group label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n.fa-group select {\n  padding: 10px 12px;\n  border: 1.5px solid #ddd;\n  border-radius: 10px;\n  font-size: 14px;\n  background: white;\n  outline: none;\n  cursor: pointer;\n}\n.fa-group select:focus { border-color: #f97316; }\n\n/* Tip butoane */\n.fa-group-tip { grid-column: 1 / -1; }\n\n.fa-tip-butoane {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.fa-tip-btn {\n  padding: 10px 20px;\n  border: 2px solid #ddd;\n  border-radius: 10px;\n  background: white;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n.fa-tip-btn:hover { border-color: #f2c94c; }\n.fa-tip-btn.activ-gasit {\n  background: #dcfce7;\n  border-color: #16a34a;\n  color: #16a34a;\n}\n.fa-tip-btn.activ-pierdut {\n  background: #fee2e2;\n  border-color: #dc2626;\n  color: #dc2626;\n}\n\n/* Acțiuni */\n.fa-actiuni { display: flex; gap: 12px; flex-wrap: wrap; }\n\n.fa-btn-cauta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 28px;\n  background: #ffcc00;\n  color: white;\n  border: 2px solid #1a1a1a;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 3px 3px 0px #1a1a1a;\n  transition: all 0.2s;\n}\n.fa-btn-cauta:hover {\n  transform: translate(-2px, -2px);\n  box-shadow: 5px 5px 0px #1a1a1a;\n}\n.fa-btn-cauta:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.fa-btn-reset {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 20px;\n  background: white;\n  color: #666;\n  border: 1.5px solid #ddd;\n  border-radius: 12px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.fa-btn-reset:hover { background: #f3f4f6; }\n\n@media (max-width: 600px) {\n  .fa-body { flex-direction: column; }\n  /* .fa-grid { \n    grid-template-columns: repeat(2, 1fr); \n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
